module.exports = __webpack_public_path__ + "static/media/default_bell.0b010497.svg";